import React, { FC } from 'react';

import { Box, Heading, Link, Container, Text } from '@lucid/components-react';
import ReactHtmlParser from 'react-html-parser';
import { LucidTheme, mqMin, mqMax } from '@lucid/theme';

import { ComponentLink } from '../../types/generics';

export interface VerticalHeroProps {
  ctas?: ComponentLink[];
  header: string | string[];
  subheader?: string;
  backgroundImage?: string;
  noSidePadding?: boolean;
  isImageFullWidth?: boolean;
}

const VerticalHero: FC<VerticalHeroProps> = ({ ctas, header, subheader, backgroundImage, noSidePadding, isImageFullWidth }) => {
  return (
    <Box as="section" pt={{ default: 7 }}>
      <Container
        css={(theme: LucidTheme) => ({
          label: 'Container',
          marginBottom: theme.space[10],
          [mqMin.tabletLandscape]: {
            display: 'flex',
            justifyContent: 'center'
          }
        })}
        extraPadding={3}
        noSidePadding={noSidePadding}
      >
        <Box css={{ label: 'verticalHero', textAlign: 'center' }}>
          <Heading
            as="h2"
            margin="0 auto"
            maxWidth={{ default: '30rem', tablet: '40rem', computer: '36.25rem' }}
            mb={{ default: 4, tablet: 8 }}
            textAlign="center"
            variant="headline2XL"
          >
            {header && Array.isArray(header)
              ? ReactHtmlParser(header.join('<br/>'))
              : header}
          </Heading>
          {backgroundImage && (
            <img
              alt="Hero Background"
              css={(theme: LucidTheme) => ({
                objectFit: 'contain',
                marginBottom: theme.space[4],
                width: '100%',
                [mqMax.mobile]: {
                  width: isImageFullWidth ? '100vw' : '100%',
                  maxWidth: isImageFullWidth ? '100vw' : '100%',
                  transform: isImageFullWidth ? 'translateX(-1.875rem)' : 'none'
                }
              })}
              loading="lazy"
              src={backgroundImage}
            />
          )}
          <Box pb={{ default: 6 }} pt={{ mobile: 0, tabletSmall: 0 }}>
            {subheader && <Text css={{ margin: '0 auto', maxWidth: '40rem', computer: '36.25rem' }} variant="paragraphM400">{subheader}</Text>}
          </Box>
          {ctas &&
            ctas.map((cta, index) => (
              <Link
                key={index}
                primary
                css={{
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'center'
                }}
                hasArrow={cta.hasArrow}
                to={cta.linkUrl!}
              >
                {cta.linkText}
              </Link>
            ))}
        </Box>
      </Container>
    </Box>
  );
};

export { VerticalHero };
export default VerticalHero;
